import { render, staticRenderFns } from "./TicketComment copy.vue?vue&type=template&id=1cf31557&scoped=true"
import script from "./TicketComment copy.vue?vue&type=script&lang=js"
export * from "./TicketComment copy.vue?vue&type=script&lang=js"
import style0 from "./TicketComment copy.vue?vue&type=style&index=0&id=1cf31557&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf31557",
  null
  
)

export default component.exports